<template>
  <div class="border_dark" style="">
    <div class="color_blue" style="display: flex">
      <div style="float: left">  {{ $t('packingb2b.boxContentDetails')}}</div>
       <div style="text-align: right; float: right; margin-left: auto">
        Total Qty:{{ qty }}
      </div> 
    </div>
    <div >
    <div v-for="boxitem in box" v-bind:key="boxitem" class="form-group">
      <single-box-item :boxdata="boxitem"></single-box-item>
    </div>
  </div>
  </div>
</template>

<script>
import SingleBoxItem from "./singleBoxItem.vue";

export default {
  name: "Boxtable",
  components: { SingleBoxItem },
  props: ["box", "qty"],

  data: function () {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style>
/* .color_blue {
  background-color: #20a8d8;
  height: 30px;
  border: 1px solid #163a2f;
  border-radius: 5px;
  margin: 0 0 0.6rem;
  padding: 5px 10px;
  color: white;
}
.border_dark {
  border: 1px solid #ffffff;
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(148, 150, 151, 0.747);
} */
.color_blue {
  background-color: #20a8d8;
  height: 30px;
  border: 1px solid #163a2f;
  border-radius: 5px;
  margin: 0 0 0.6rem;
  padding: 5px 10px;
  color: white;
}
.border_dark {
  border: 1px solid #ffffff;
  border-radius: 5px;
  box-shadow: 0px 2px 4px rgba(148, 150, 151, 0.747);
}
</style>



// WEBPACK FOOTER //
// src/views/common_components/boxTable.vue?9ce8196c